/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

let timeoutID = 0;

const PASSWORD_NOPE = 'Too short - 8 character minimum';
const PASSWORD_OK = '';
const PASSWORD_GOOD = '';

class PasswordField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password : '',
            strength: {}
        };

        this.onUpdateField = this.onUpdateField.bind(this);
        //this.testPassword = this.testPassword.bind(this);

    }


    onUpdateField(e) {

        this.setState({
            password: e.currentTarget.value
        });

        this.props.changeCallback({
            password: e.currentTarget.value,
            score: 0
        });

    }

    // testPassword(e) {
    //
    //     if (timeoutID !== 0) {
    //         window.clearTimeout(timeoutID);
    //     }
    //
    //     timeoutID = window.setTimeout(() => {
    //         if (zxcvbn) {
    //             let result = {score: 0};
    //
    //             if (this.state.password.length > this.props.minLength) {
    //                 result.score = 4;
    //             }
    //
    //             this.setState({
    //                 strength: result
    //             });
    //             this.props.changeCallback({
    //                 password: this.state.password,
    //                 score: result.score
    //             });
    //         }
    //     }, this.props.timeoutInterval);
    //
    // }

    render() {
        let mainClass = "dlvr-password",
            meterClass = "password-meter",
            scoreClass = '',
            feedback = [
                PASSWORD_NOPE,
                PASSWORD_NOPE,
                PASSWORD_NOPE,
                PASSWORD_OK,
                PASSWORD_GOOD
            ],
            feedbackElement = null,
            feedbackClass = 'password-feedback';

        if (this.state.strength.score !== undefined) {
            if (parseInt(this.state.strength.score, 10) === 4) {
                scoreClass = ' good';
            } else {
                scoreClass = ' weak';
            }

            if (this.state.password !== '') {
                meterClass += scoreClass;
            }
            mainClass += scoreClass;
            feedbackClass += scoreClass;
        }


        feedbackElement = (
            <div className='password-feedback default'>At least 8 characters long</div>
        );


        return (
            <div className={mainClass}>
                <input
                    {...this.props.inputProps}
                    type="password"
                    value={this.state.password}
                    onChange={this.onUpdateField}/>
                <div className="password-strength-wrapper">
                    {feedbackElement}
                </div>
            </div>
        );
    }
}

PasswordField.displayName = "PasswordField";

PasswordField.propTypes = {
    inputProps: PropTypes.object,
    changeCallback: PropTypes.func,
    minLength: PropTypes.number,
    minScore: PropTypes.number
};

PasswordField.defaultProps = {
    inputProps: {},
    changeCallback: () => {},
    minLength: 7,
    minScore: 2,
    timeoutInterval: 100
};

export default PasswordField;
